/*
 * @Author: zhangyuansheng zhangyuansheng@elinkmart.com
 * @Date: 2025-02-20 15:13:00
 * @LastEditors: zhangyuansheng zhangyuansheng@elinkmart.com
 * @LastEditTime: 2025-03-10 16:36:08
 * @FilePath: \产品网站3.0\src\router\modules\price.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const SubscribeRoute = [
  // 预约申请
    {
      path: "/Subscribe",
      name: "Subscribe",
      component: () => import("../../views/ecologycooperation/components/addCustomer.vue"),
      // meta: {
      //   title: "CherryMe移动办公",
      //   keywords: '登录认证, 即时通讯,办公协同,意见与建议,公众号',
      //   description: 'AI时代提供智能、惠普、开放、简单的产品能力'
      // },
    },
    //  服务中心
    {
      path: "/Servicecentre",
      name: "Servicecentre",
      component: () => import("../../views/servicecentre/index.vue"),
      children: [
        {
          path: "",
          // component: () => import("../page/home/home.vue"),
        },
      ]
      // meta: {
      //   title: "CherryMe移动办公",
      //   keywords: '登录认证, 即时通讯,办公协同,意见与建议,公众号',
      //   description: 'AI时代提供智能、惠普、开放、简单的产品能力'
      // },
    },
    //  视频中心
    {
      path: "/vidioStar",
      name: "vidioStar",
      component: () => import("../../views/servicecentre/vidioStar/index.vue"),
      // meta: {
      //   title: "CherryMe移动办公",
      //   keywords: '登录认证, 即时通讯,办公协同,意见与建议,公众号',
      //   description: 'AI时代提供智能、惠普、开放、简单的产品能力'
      // },
    },
  ];